import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthorizationService, AssociationService } from './../../../../shared/index';

@Component({
    selector: 'master-index',
    templateUrl: './master-index.html',
    standalone: false
})

export class MasterIndexComponent implements OnInit, OnDestroy {
    public companyvisible = true;
    public minesitevisible = true;
    public equipmentvisible = true;

    private subscriptions: Subscription[] = [];

    constructor(
        private _authorizationService: AuthorizationService,
        private _associationService: AssociationService
    ) {
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
